export const SET_BASES = "SET_BASES";
export const ADD_BASE = "ADD_BASE";
export const SET_BASE = "SET_BASE";
export const SET_BASE_STATUS = "SET_BASE_STATUS";
export const REMOVE_BASE = "REMOVE_BASE";
export const SET_ALL_BASES = "SET_ALL_BASES";
